import useErrorModal from "./useErrorModal";

const useVideoValidation = () => {
    const { showErrorModal, ErrorModal } = useErrorModal();

    const validateVideo = (file: File): Promise<string | null> => {
        return new Promise((resolve, reject) => {
            if (file.type !== "video/mp4") {
                showErrorModal('Не удалось загрузить видео', 'Файл должен быть формата .mp4');
                return;
            }

            if (file.size > 4 * 1024 * 1024 * 1024) {
                showErrorModal('Не удалось загрузить видео', 'Файл не должен превышать размер 4 ГБ');
                return;
            }

            const videoURL: string = URL.createObjectURL(file);
            const video: HTMLVideoElement = document.createElement('video');
            video.src = videoURL;
            video.onloadedmetadata = () => {
                if (video.videoWidth < 1280 || video.videoHeight < 720) {
                    URL.revokeObjectURL(videoURL);
                    showErrorModal('Не удалось загрузить видео', 'Разрешение видео должно быть не ниже 1280x720');
                } else {
                    resolve(null);
                }
            };
        });
    };
    return { validateVideo, ErrorModal };
};

export default useVideoValidation;
